import React from "react";
import { HiOutlineShoppingBag } from "react-icons/hi";

import DoSeeListPage from "../../../layout/DoSeeListPage";
import { _TYPES_ } from "../utils/types";
import { pushOneShopping } from "../../../lib/sysNavigation/SysNavigation";

type ShoppingRow = {
  shopping_id: number | string;
  title?: string;
  slug?: string;
  [key: string]: unknown;
};

const Overview: React.FC = () => (
  <DoSeeListPage<ShoppingRow>
    type={_TYPES_.SHOPPING}
    title="Shopping"
    subtitle="Shopping destinations promoted on the public site."
    icon={<HiOutlineShoppingBag className="h-5 w-5" />}
    addRoute="/data/shopping/add"
    editRoute="/data/shopping/edit"
    pushOne={pushOneShopping}
    dataKey="shoppings"
    countKey="shoppingsCount"
    idField="shopping_id"
  />
);

export default Overview;
